export default __webpack_public_path__ + "static/media/dog-silhouette-gray.82d84cef.svg";